// extracted by mini-css-extract-plugin
export var numpadContainer = "_n5-1";
export var phoneButton = "_n5-0";